type Sign = "positive" | "negative" | "zero";
export default function parseNumber(input: string): [number, Sign] {
	let trimmed = input.trim();
	let sign: Sign = "zero";
	if (trimmed.endsWith("%")) {
		trimmed = trimmed.slice(0, -1).trim();
	}

	const value = Number.parseFloat(trimmed);

	if (Number.isNaN(value)) {
		return [0, sign];
	}

	if (value > 0) {
		sign = "positive";
	}
	if (value < 0) {
		sign = "negative";
	}
	return [value, sign];
}
